import {
  ExternalAccountInvitation,
  InvitationStatus,
  LanguageNameSpaces,
} from "@shared/types";
import StatusTag from "common/Tags/StatusTag.tsx";
import React from "react";
import { useTheme } from "styled-components";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface InvitationStatusProps {
  invitation: ExternalAccountInvitation;
}

const InvitationStatusTag = ({ invitation }: InvitationStatusProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  const theme = useTheme();

  let color = theme.colors.green;
  let text = t("invitations.active");
  if (invitation.status === InvitationStatus.EXPIRED) {
    color = theme.colors.red;
    text = t("invitations.expired");
  } else if (invitation.status === InvitationStatus.USED) {
    color = theme.colors.primaryBlue;
    text = t("invitations.used");
  }

  return (
    <StatusTag
      text={text}
      color={color}
      animated={false}
      style={{ width: "fit-content" }}
    />
  );
};

export default InvitationStatusTag;
